/* eslint-disable @next/next/no-img-element */
import { getAssets } from "@unisearch/helpers";
import moment from "moment";
import Image from "next/legacy/image";
import Link from "next/link";
import React from "react";
import styles from "./vlog_video_carosel.module.scss";

export const VlogVideoCarosel = ({ item }) => {
  return (
    <div className={styles.wrapper}>
      {/* <img src={item?.featuredImage?.src} alt={item?.title} /> */}
      <Image
        layout="responsive"
        width={550}
        height={280}
        blurDataURL={getAssets("assets/images/image_placeholder_big.webp")}
        placeholder="blur"
        className={styles.carousel_image}
        src={
          item?.featuredImage?.src ||
          getAssets("assets/images/image_placeholder_big.webp")
        }
        alt={item?.title}
      />
      <div className={styles.details_background}></div>
      <div className={styles.details}>
        <Link legacyBehavior href={`/vlog/${item?.slug}`}>
          <a className={styles.title}>{item?.title}</a>
        </Link>
        <div className={styles.detail}>
          {item?.totalView} Views ●{" "}
          {moment(item?.publishedDate).format("MMMM DD, YYYY")}
        </div>
      </div>
    </div>
  );
};

export default VlogVideoCarosel;
